import { signIn, type SignInOutput } from "aws-amplify/auth";

/**
 * Start a USER_AUTH session that goes straight to an email code; Cognito sends
 * it, and the next step asks for it.
 *
 * "Email me a code" on the sign-in screen and "Send a new code" on the code
 * screen are this same call. Cognito has no resend for a sign-in code, so
 * another code means another session anyway.
 *
 * Nothing asks Cognito what a given account can do first. Since passwords were
 * retired the pool offers exactly two first factors, a passkey and this, and
 * both are offered to everyone: a code reaches whoever holds the address, and
 * the passkey ceremony is the browser's to refuse. Asking in advance only told
 * a stranger which accounts exist.
 */
export function requestEmailCode(email: string): Promise<SignInOutput> {
    return signIn({
        username: email.trim(),
        options: { authFlowType: "USER_AUTH", preferredChallenge: "EMAIL_OTP" },
    });
}
